import { render, staticRenderFns } from "./broadcastlist.vue?vue&type=template&id=5bdd611a&"
import script from "./broadcastlist.vue?vue&type=script&lang=js&"
export * from "./broadcastlist.vue?vue&type=script&lang=js&"
import style0 from "./broadcastlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports